<template lang="pug">
validation-provider(v-slot="{ errors, invalid, validated, required }" :rules="rules" :name="name" tag="div" class="v-form-inner")
  dt(:class="required ? 'required' : 'optional'")
    label(:for="label" v-html="title || name")
  dd(:class="{ 'is-error': invalid && validated }")
    .error-message(v-html="errors[0]")
    .caption(v-if="caption" v-html="caption")
    .job-form-point(v-if="point")
      p(v-html="point")
    textarea(:id="label" :class="className" v-model="currentValue" :placeholder="placeholder")
    div(v-html="html")
</template>

<script>
export default {
  name: 'FormTextarea',
  props: {
    point: {
      type: String,
      default: null
    },
    className: {
      type: String,
      default: null
    },
    value: {
      type: String,
      default: ''
    },
    vid: {
      type: String,
      default: undefined
    },
    // エラーメッセージ「〇〇は必須項目です」を書き換える。項目タイトルとしても使用可能。
    name: {
      type: String,
      default: ''
    },
    // 項目タイトルのみで使用。
    // タイトル内にHTMLの改行などを追加する場合は、こちらを使用する。
    // エラーメッセージをデフォルトから変更している場合も、こちらを使用する。(nameを設定すると、エラーメッセージが上書きされてしまうため。)
    title: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    caption: {
      type: String,
      default: ''
    },
    html: {
      type: String,
      default: ''
    },
    rules: {
      type: [Object, String],
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    currentValue: ''
  }),
  watch: {
    currentValue(val) {
      // allows us to use v-model on our input.
      this.$emit('input', val)
    },
    value(val) {
      if (val !== this.currentValue) {
        this.currentValue = val
      }
    }
  },
  created() {
    if (this.value) {
      this.currentValue = this.value
    }
  }
}
</script>
